export class MessageDialogData {
  title: string;
  texts: string[];
}
